import React from "react";
import { Image, ImageProps } from "antd";

const ZImage: React.FC<ImageProps> = ({ src, alt, ...rest }) => {
	return <Image src={src} alt={alt} {...rest} />;
};

export default ZImage;
